import { render, staticRenderFns } from "./GroupInstructors.vue?vue&type=template&id=3c04125a"
import script from "./GroupInstructors.vue?vue&type=script&lang=js"
export * from "./GroupInstructors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports